import Toaster from './Toaster';

export default Toaster;



// WEBPACK FOOTER //
// ./src/Components/Feedback/Components/Toaster/index.tsx